import React from 'react';
import { Alert, Button, Paper, Stack, Typography } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';

type Props = {
  allowed: boolean;
  title?: string;
  message?: string;
  actionLabel?: string;
  onAction?: () => void;
  children: React.ReactNode;
};

class FWizardGuard extends React.PureComponent<Props> {
  render() {
    if (this.props.allowed) return this.props.children;

    return (
      <Paper elevation={1} sx={{ p: 2 }}>
        <Stack spacing={2}>
          <Alert severity="warning" icon={<LockIcon />}>
            <Typography variant="subtitle2" sx={{ fontWeight: 800 }}>
              {this.props.title || 'Step Locked'}
            </Typography>
            <Typography variant="body2">
              {this.props.message || 'Complete the previous requirements before continuing.'}
            </Typography>
          </Alert>

          {this.props.onAction && (
            <Button variant="outlined" onClick={this.props.onAction}>
              {this.props.actionLabel || 'Resolve Requirement'}
            </Button>
          )}
        </Stack>
      </Paper>
    );
  }
}

export default FWizardGuard;
